import styled from 'styled-components';

const FilterButton = styled.button`
  ${({ theme }) => theme.typographyRebrand.body.md}
  background-color: transparent;
  color: ${(p) => p.theme.c.button.light.secondary.text.default};
  border: 1px solid ${(p) => p.theme.c.button.light.secondary.border.default};
  padding: ${p => p.theme.unit(0.5)} ${(p) => p.theme.unit(1)};
  margin: ${p => p.theme.unit(0.5)} 0;
  cursor: pointer;
  :hover {
    background-color: ${(p) => p.theme.c.button.light.secondary.background.hover};
    color: ${(p) => p.theme.c.button.light.secondary.text.hover};
  }
`;

const FilterActiveButton = styled(FilterButton)`
  background-color: ${(p) => p.theme.c.button.light.secondary.border.pressed};
  border-color: ${(p) => p.theme.c.button.light.secondary.border.pressed};
  color: ${(p) => p.theme.c.button.dark.secondary.text.default};
`;

const FilterContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const CategoryFilterComponent = (props) => {
  const {
    categoryFiltersDictionary,
    toggleFilter,
  } = props;

  return (<FilterContainerDiv>
    {Object.keys(categoryFiltersDictionary).map((facet) => {
      const FilterCompToUse = categoryFiltersDictionary[facet] ? FilterActiveButton : FilterButton;
      return (
        <FilterCompToUse
          key={`facet-filter-${facet}`}
          onClick={() => { toggleFilter(facet); }}>
          {facet}
        </FilterCompToUse>
      );
    })}
  </FilterContainerDiv>);
};

export default CategoryFilterComponent;
